module.exports = __webpack_public_path__ + "static/img/bg9.5bc73ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg9.jpg
// module id = dZcM
// module chunks = 1